export const TOGGLE_DISCOUNTED_ITEMS = '[Bulletin]/TOGGLE_DISCOUNTED_ITEMS';
export const TOGGLE_NEW_PRODUCTS = '[Bulletin]/TOGGLE_NEW_PRODUCTS';
export const TOGGLE_NOTICES = '[Bulletin]/TOGGLE_NOTICES';

export const GET_BULLETIN_ITEMS_PENDING = '[Bulletin]/GET_BULLETIN_ITEMS_PENDING';
export const GET_BULLETIN_ITEMS_SUCCESS = '[Bulletin]/GET_BULLETIN_ITEMS_SUCCESS';
